<!-- Activity Cards -->
<section
  *ngIf="activities?.length > 0"
  class="activities tw-flex tw-flex-column tw-gap-2">
  <button
    *ngFor="let activity of activities"
    (click)="select(activity)"
    class="activities-select"
    type="button"
    [tabindex]="-1"
    [ngClass]="{ active: selectedId === activity.id }">
    <mg-ftm-activity-card
      [activity]="activity"
      [visibleFields]="activityCardFields"
      [selected]="selectedId === activity.id">
    </mg-ftm-activity-card>
  </button>
</section>

<!-- Empty State -->
<div
  *ngIf="noResults && activities?.length === 0"
  class="no-results">
  <ng-container *ngTemplateOutlet="noResults"></ng-container>
</div>
